import type {ReactElement} from 'react';
import React from 'react';
import {BaseFontSizeOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-font-size-option';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetSelectedSlideId} from '@Hooks/poster-editor/useGetSelectedSlideId';
import {useGetKeyFromTextStylesOfSelectedTextSlideItem} from '@Hooks/poster-editor/useGetKeyFromTextStylesOfSelectedTextSlideItem';
import {useGetKeyfromSlideshowItem} from '@Hooks/poster-editor/useGetKeyfromSlideshowItem';

export function TextSlideSizeOption(): ReactElement<any> {
  const activeItemId = useSingleActivePosterItemId();
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const activeSlideUID = useGetSelectedSlideId();
  const fontSize = useGetKeyFromTextStylesOfSelectedTextSlideItem('fontSize');
  const scaleX = useGetKeyfromSlideshowItem('scaleX');

  if (!activeItem?.isSlideshow()) {
    throw new Error(`Expected slideshow item but got ${activeItem?.gitype}`);
  }

  if (activeSlideUID === undefined) {
    throw new Error('active slide uid does not exist');
  }

  if (fontSize === undefined || scaleX === undefined) {
    throw new Error(`Text Slide doesn't have font size property`);
  }

  const updateFontSize = (fontSize: number, undoable = true): void => {
    void activeItem.updateSlideFromObject(
      activeSlideUID,
      {
        textStyles: {
          fontSize,
        },
      },
      {
        undoable,
      }
    );
  };

  return <BaseFontSizeOption fontSize={fontSize} scale={scaleX} onUpdateFontSize={updateFontSize} />;
}
